<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    :style="{ height: tableHeight2 }"
    :class="['l-table', isPage ? 'l-table--haspagination' : '']"
  >
    <el-table
      :data="tableShowData"
      style="width: 100%"
      :height="tableHeight"
      :max-height="maxHeight"
      size="mini"
      :cell-style="cellStyle || { padding: '5px 0' }"
      :header-cell-style="{
        padding: '5px 0',
        'background-color': '#fafafa !important',
      }"
      :stripe="stripe"
      :border="border"
      :fit="fit"
      :show-header="showHeader"
      :highlight-current-row="highlightCurrentRow"
      :current-row-key="currentRowKey"
      :row-key="rowKey"
      :row-class-name="rowClassName"
      :cell-class-name="cellClassName"
      :header-row-class-name="headerRowClassName"
      :header-cell-class-name="headerCellClassName"
      :default-expand-all="defaultExpandAll"
      :expand-row-keys="expandRowKeys"
      :default-sort="defaultSort"
      :tooltip-effect="tooltipEffect"
      :show-summary="showSummary"
      :sum-text="sumText"
      :summary-method="getSummaries"
      :span-method="spanMethod"
      :select-on-indeterminate="selectOnIndeterminate"
      :indent="indent"
      :lazy="lazy"
      :load="load"
      :tree-props="treeProps"
      :row-style="rowStyle"
      @select="handleSelect"
      @select-all="handleSelectAll"
      @selection-change="selectionChange"
      @cell-mouse-enter="cellMouseEnter"
      @cell-mouse-leave="cellMouseLeave"
      @cell-click="cellClick"
      @cell-dblclick="cellDblclick"
      @row-click="rowClick"
      @row-contextmenu="rowContextmenu"
      @row-dblclick="rowDblclick"
      @header-click="headerClick"
      @header-contextmenu="headerContextmenu"
      @sort-change="sortChange"
      @filter-change="filterChange"
      @current-change="currentChange"
      @header-dragend="headerDagend"
      @expand-change="expandChange"
      ref="learunTable"
      v-if="isShowTable"
    >
      <!-- 拖动排序  -->
      <el-table-column align="center" width="45" v-if="isSortable && !isTree">
        <template slot="header">
          <i class="el-icon-sort" />
        </template>
        <template>
          <span class="learun-table__drag-handler">
            <i class="el-icon-rank" />
          </span>
        </template>
      </el-table-column>

      <el-table-column
        v-if="isExpand"
        :fixed="isFixed"
        type="expand"
        v-slot="scope"
        width="28"
      >
        <slot v-bind="scope" name="table_expand"></slot>
      </el-table-column>

      <el-table-column
        v-if="isMultiSelect"
        :fixed="isFixed"
        type="selection"
        width="45"
        align="center"
        :selectable="selectable"
      ></el-table-column>

      <el-table-column
        v-if="isShowNum"
        :label="ShowNumLabel"
        :fixed="isFixed"
        type="index"
        align="center"
        :index="indexMethod"
      >
      </el-table-column>

      <template v-for="(item, index) in tableColumns">
        <el-table-column
          :key="item.guid || item.prop || index"
          v-bind="item"
          :label="$t(item.label)"
          :show-overflow-tooltip="item.isNotAutoWrap == true ? true : false"
          :fixed="isSortable && !isTree ? false : item.fixed"
          :sortable="sortable || item.sortable"
          v-if="!item.children"
        >
          <template v-slot:header="{ column }">
            <span v-if="isRequired(column.property)" style="color: red">*</span
            ><span>{{ column.label }}</span
            ><slot v-if="item.showSlot" :name="item.showSlot"></slot>
          </template>
          <template v-slot="slotProps">
            <slot v-bind="slotProps" :name="item.prop">{{
              columnText(slotProps.$index, slotProps.row, item, slotProps)
            }}</slot>
          </template>
        </el-table-column>
        <dynamic-column
          v-else
          :columnOption="item"
          :columnText="columnText"
          :isRequired="isRequired"
          :key="item.guid || index"
          :label="$t(item.label)"
          :showOverflowTooltip="item.isNotAutoWrap == true ? true : false"
          :fixed="isSortable && !isTree ? false : item.fixed"
          :sortable="sortable"
          :allProps="item.props"
        >
          <template v-for="myProp in item.props || []" v-slot:[myProp]="scope">
            <slot v-bind="scope" :name="myProp"></slot>
          </template>
        </dynamic-column>
      </template>
      <slot></slot>
    </el-table>
    <div v-if="isPage" class="l-table--pagination">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes || [20, 50, 100, 200]"
        :page-size.sync="pageSize2"
        layout="slot,total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      >
        <div style="float: left">
          <el-button icon="el-icon-setting" @click="showColumnsSetting">
            {{ openColumns_Des }}</el-button
          >
          <el-button
            icon="el-icon-download"
            @click="exportBtn_Click"
            v-if="isExport"
            >导出</el-button
          >
        </div>
      </el-pagination>
    </div>
    <l-drawer
      :title="$t('表格列设置')"
      :visible.sync="columnsVisible"
      :showOk="false"
      :showClose="false"
      :wrapperClosable="true"
      :modal="false"
      size="320px"
      @opened="columnsSettingOpened"
    >
      <el-tree
        ref="columnsTree"
        node-key="_id"
        show-checkbox
        :data="treeColumns"
        @check="handleColumnsCheck"
      >
      </el-tree>
    </l-drawer>

    <!-- 勾选需要导出的字段 -->
    <l-dialog
      v-if="dataUrl != ''"
      :title="$t(fileName)"
      :visible.sync="exportVisible"
      :width="600"
      :height="400"
      @ok="handleExport"
    >
      <div class="l-rblock export-wraper" style="padding: 8px">
        <el-alert
          title="提示"
          type="warning"
          description="请勾选需要导出的字段"
          show-icon
          :closable="false"
          style="margin-bottom: 16px"
        >
        </el-alert>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="exportGroup"
          size="small"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox
            style="margin-bottom: 8px; display: block; width: 50%"
            v-for="item in finalColumns"
            :key="item.prop"
            :label="item.prop"
            border
            >{{ $t(item.label) }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
    </l-dialog>
  </div>
</template>
<script>
import tableEvent from "@util/tableEvent";
import dynamicColumn from "./dynamic-column";
export default {
  name: "l-table",
  mixins: [tableEvent()],
  components: {
    dynamicColumn,
  },
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    columnsType: {
      type: String,
      default: "tree",
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    memoryColWidth: {
      type: Boolean,
      default: true,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: true,
    },
    fit: {
      type: Boolean,
      default: true,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },

    currentRowKey: [String, Number],
    rowKey: [String, Function],

    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],

    defaultExpandAll: Boolean,
    expandRowKeys: {
      type: Array,
    },

    defaultSort: Object,

    tooltipEffect: String,

    showSummary: {
      type: Boolean,
      default: false,
    },
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,
    spanMethod: Function,

    selectOnIndeterminate: {
      type: Boolean,
      default: true,
    },

    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    treeProps: Object,

    isPage: {
      type: Boolean,
      default: false,
    },
    sumsIsMoney: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },

    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "#",
    },
    isMultiSelect: Boolean,
    reserveSelection: {
      type: Boolean,
      default: true,
    },

    isTree: {
      type: Boolean,
      default: false,
    },
    pidKey: {
      type: String,
    },
    selectKey: String,
    sortable: {
      type: Boolean,
      default: false,
    },
    isSortable: {
      type: Boolean,
      default: false,
    },

    isExpand: {
      type: Boolean,
      default: false,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    pageSize: {
      type: Number,
      default: 50,
    },
    required: {
      type: Boolean,
      default: false,
    },

    //导出的相关
    queryData: Object, //查询条件
    dataUrl: {
      //后端接口地址
      type: String,
      default: "",
    },
    fileName: {
      //导出文件名
      type: String,
      default: "导出列表数据",
    },
    isExport: {
      //是否显示导出按钮
      type: Boolean,
      default: false,
    },

    customExportFunc: Function,
    exportColumns: {
      //特殊的导出列---如果有传值，以此为主，无值使用默认的columns
      type: Array,
      default: () => [],
    },
    selectable: Function,
  },
  data() {
    return {
      queryIndex: 0,
      selectedData: [],
      columnsVisible: false,
      columnsChecks: null,
      pageSize3: 0,
      isShowTable: true,
      oldColumns: this.$deepClone(this.columns),
      orginColumns: this.$deepClone(this.columns),
      itemId: "",

      column_TotalNum: this.$deepClone(this.columns).length, //表格总列数
      column_HideNum: 0, //表格隐藏的列数
      openColumns_Des:
        "共" + this.$deepClone(this.columns).length + "列/隐藏0列", //操作列，说明

      exportVisible: false, //显示要导出的列设置弹出窗标识
      exportGroup: [], //导出的列字段选项组
      columnsProp: [], //列字段的属性名
      isIndeterminate: false, // 表示 checkbox 的不确定状态
      checkAll: false, //是否全选
      finalColumns: [], //最终的表格列
    };
  },
  mounted() {
    this.itemId =
      this.md5Object(this.orginColumns) +
      this.$md5(this.$router.currentRoute.path);
    this.setSort();
    if (this.isChild) {
      const list = this.$el.querySelectorAll(".el-table__row");
      list.forEach((row) => {
        row.classList.add("el-table__row2");
        row.classList.remove("el-table__row");
      });
    }
    if (this.memoryColWidth) {
      this.getSettingColData();
    }
  },
  computed: {
    pageSize2: {
      get() {
        if (this.pageSize3 != 0) {
          return this.pageSize3;
        }
        return this.pageSize;
      },
      set(val) {
        this.pageSize3 = val;
        this.$emit("update:pageSize", val);
      },
    },
    isFixed() {
      return (
        this.arrayColumns.find((item) => {
          return item.fixed || item.fixed === "left" || item.fixed === "right";
        }) != undefined && !this.isSortable
      );
    },
    tableHeight() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return "100%";
      }
    },
    tableHeight2() {
      if (this.height == "notset" || this.isChild) {
        return;
      } else {
        return this.height;
      }
    },
    currentPage: {
      get() {
        if (!this.$validatenull(this.tablePage)) {
          return this.tablePage;
        } else {
          return 1;
        }
      },
      set(val) {
        this.$emit("update:tablePage", val);
      },
    },
    tableShowData() {
      if (this.isTree) {
        return this.$toTree(
          this.dataSource,
          this.multiSelectKey,
          this.pidKey,
          this.multiSelectKey,
          this.multiSelectKey
        );
      } else {
        return this.dataSource;
      }
    },
    multiSelectKey() {
      if (this.selectKey) {
        return this.selectKey;
      } else if (typeof this.rowKey == "string") {
        return this.rowKey;
      } else {
        return this.selectKey;
      }
    },
    selectedValues() {
      return this.selectedData.map((t) => t[this.multiSelectKey]);
    },
    arrayColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      if (this.columnsType == "tree") {
        return this.$toArray(this.columns);
      } else {
        return this.columns;
      }
    },
    treeColumns() {
      // 列的数据结构是树形结构，方便处理需要转成数组结构
      return this.$toTree(this.$deepClone(this.arrayColumns));
    },
    tableColumns() {
      if (this.arrayColumns.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }
      let res;
      if (!this.memoryColWidth) {
        res = this.columns;
      } else {
        res = this.oldColumns.filter(
          (item) => item.visble == undefined || item.visble
        );
      }
      if (res.length == 0) {
        return [{ label: "", prop: "learun_null", minWidth: "1" }];
      }
      return res;
      //return this.columns
    },
    defaultCheckedKeys() {
      return this.arrayColumns
        .filter((t) => t.isNotShow != true)
        .map((t) => t._id);
    },
  },
  watch: {
    dataSource() {
      if (this.isChild) {
        const list = this.$el.querySelectorAll(".el-table__row");
        list.forEach((row) => {
          row.classList.add("el-table__row2");
          row.classList.remove("el-table__row");
        });
      }
      this.selectRows();

      // 2023.12.21
      if (this.memoryColWidth) {
        this.getSettingColData();
      }
    },
  },
  methods: {
    //导出的按钮点击事件
    exportBtn_Click() {
      // 自定义导出
      if (this.customExportFunc) {
        this.customExportFunc;
        return;
      }

      console.log("导出接口地址", this.dataUrl);

      this.columnsProp = []; //先清空表格属性数组
      this.finalColumns =
        this.exportColumns.length == 0 ? this.columns : this.exportColumns;
      if (this.dataUrl != "") {
        this.finalColumns.forEach((item) => {
          this.columnsProp.push(item.prop);
        });
        this.exportVisible = true; //显示选择导出的列弹出框
      } else {
        this.$message("导出接口地址未配置，请联系管理员添加");
      }
    },

    //全选
    handleCheckAllChange(val) {
      this.exportGroup = val ? this.columnsProp : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.columnsProp.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.columnsProp.length;
    },
    //导出
    async handleExport() {
      if (this.exportGroup.length == 0) {
        this.$message({
          message: "请勾选需要导出的字段",
          type: "warning",
        });
        return;
      }

      let columns = this.finalColumns.filter(
        (t) => this.exportGroup.indexOf(t.prop) > -1
      ); //获取导出的列
      let queryData = this.$deepClone(this.queryData);
      queryData.isExport = true; //是否导出查询标识
      await this.CommonExport(
        this.fileName, //导出的文件名
        columns, //列名
        this.dataUrl, //导出地址
        queryData //查询条件
      );
      this.exportVisible = false; //关闭选择列字段的弹出框
    },

    indexMethod(index) {
      if (this.isPage) {
        return (this.currentPage - 1) * this.pageSize2 + index + 1;
      } else {
        return index + 1;
      }
    },
    async headerDagend(e, t, n, i) {
      var r = this.$router.currentRoute.path;
      this.$emit("headerDagend", e, t, n, i);
      if (this.memoryColWidth) {
        for (var z = 0; z < this.oldColumns.length; z++) {
          if (this.oldColumns[z].prop == n.property) {
            this.oldColumns[z].minWidth = parseInt(e);
            this.oldColumns[z].width = parseInt(e);
            break;
          }
        }
        var a = {
          queryIndex: 1,
          path: r,
          id: this.itemId,
          queryData: JSON.stringify(this.oldColumns),
        };
        await window.$api.system.module.addOrUpdateColData(a);
      }
    },
    async getSettingColData() {
      var i = { Id: this.itemId };
      var r = await window.$api.system.module.getSettingColData(i);
      if (
        null != r.data &&
        null != r.data.data &&
        null != r.data.data.queryData
      ) {
        var o = JSON.parse(r.data.data.queryData);
        //2023.12.21
        this.oldColumns = this.$deepClone(this.columns);

        this.oldColumns = this.mergeVisbleArray(o, this.oldColumns, "prop");
        var n = this;
        this.$nextTick(function () {
          n.$refs.learunTable.doLayout();
        });

        //初始化，给动态列操作说明赋值
        if (this.oldColumns.length > 0) {
          var columnindex = 0;
          let columnObj = this.oldColumns;
          columnObj.forEach((column) => {
            if (column.visble == false) {
              columnindex = columnindex + 1;
            }
          });
          this.column_HideNum = columnindex;
          this.openColumns_Des =
            "共" +
            this.$deepClone(this.columns).length +
            "列/隐藏" +
            columnindex +
            "列";
        }
      }
    },
    handleSizeChange(val) {
      this.pageSize2 = val;
      this.$emit("loadPageData", { rows: val, page: this.currentPage });
      //console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit("loadPageData", { rows: this.pageSize2, page: val });
    },
    doLayout() {
      this.isShowTable = false;
      this.$nextTick(() => {
        this.isShowTable = true;
      });
    },

    // 关于多选
    reset() {
      this.selectedData = [];
      this.$refs.learunTable.clearSelection();
    },
    clearSelection() {
      this.selectedData = [];
      this.$refs.learunTable.clearSelection();
    },
    getSelected() {
      return this.$deepClone(this.selectedData);
    },
    handleSelect(selection, row) {
      if (!this.reserveSelection) {
        this.$emit("select", selection, row);
        return;
      }
      // 获取增加项
      const addList = selection.filter(
        (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) == -1
      );
      if (addList.length > 0) {
        this.selectedData = addList.concat(this.selectedData);
      } else {
        // 获取当前页面没有被选中的
        let notSelectedList = this.dataSource.filter(
          (t) =>
            selection.findIndex(
              (t2) => t2[this.multiSelectKey] == t[this.multiSelectKey]
            ) == -1
        );
        // 获取减少项
        let deleteList = notSelectedList.filter(
          (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) != -1
        );
        this.selectedData = this.selectedData.filter(
          (t) =>
            deleteList.findIndex(
              (t2) => t2[this.multiSelectKey] == t[this.multiSelectKey]
            ) == -1
        );
      }

      this.$emit("select", selection, row);
    },
    handleSelectAll(selection) {
      if (this.isTree) {
        if (this.dataSource.length > 0) {
          if (
            this.dataSource.filter(
              (t) => this.selectedValues.indexOf(t[this.multiSelectKey]) != -1
            ).length < this.dataSource.length
          ) {
            let needSelectData = this.dataSource.map(
              (t) => t[this.multiSelectKey]
            );
            this.selectTreeRows2(this.tableShowData, needSelectData);
            this.handleSelect(this.dataSource);
          } else {
            // 表示全部不选中
            this.$refs.learunTable.clearSelection();
            this.handleSelect([]);
          }
        }
      } else {
        this.handleSelect(selection);
      }
      this.$emit("selectAll", selection);
    },
    selectRows() {
      if (!this.isMultiSelect || !this.reserveSelection) {
        return;
      }
      this.$nextTick(() => {
        if (this.isTree) {
          this.selectTreeRows(this.tableShowData);
        } else {
          this.dataSource.forEach((row) => {
            if (this.selectedValues.indexOf(row[this.multiSelectKey]) != -1) {
              this.$refs.learunTable.toggleRowSelection(row, true);
            }
          });
        }
      });
    },
    selectTreeRows(data) {
      data.forEach((row) => {
        if (this.selectedValues.indexOf(row.value) != -1) {
          this.$refs.learunTable.toggleRowSelection(row, true);
        }
        if (row.children) {
          this.selectTreeRows(row.children);
        }
      });
    },
    selectTreeRows2(data, selectValues) {
      data.forEach((row) => {
        if (selectValues.indexOf(row.value) != -1) {
          this.$refs.learunTable.toggleRowSelection(row, true);
        }
        if (row.children) {
          this.selectTreeRows2(row.children, selectValues);
        }
      });
    },
    showColumnsSetting() {
      this.openColumnsSetting();
    },
    // 动态显示列
    openColumnsSetting() {
      if (!this.memoryColWidth) return;
      var e = this;
      this.$colmodal({
        methods: {
          saveData: (t) => {
            e.oldColumns = this.mergeVisbleArray(t, e.oldColumns, "prop");
            var n = this;
            this.$nextTick(function () {
              n.$refs.learunTable.doLayout();
            });

            var column_index = 0;
            e.oldColumns.forEach((column) => {
              if (column.visble == false) {
                column_index = column_index + 1;
              }
            });
            e.column_HideNum = column_index;
            e.openColumns_Des =
              "共" + e.column_TotalNum + "列/隐藏" + e.column_HideNum + "列";
          },
          resetData: () => {
            e.oldColumns = this.$deepClone(e.orginColumns);
            var n = this;
            this.$nextTick(function () {
              n.$refs.learunTable.doLayout();
            });

            e.column_HideNum = 0;
            e.openColumns_Des =
              "共" + e.column_TotalNum + "列/隐藏" + e.column_HideNum + "列";
          },
        },
        componentProps: {
          id: e.itemId,
          tableData: e.oldColumns,
          queryIndex: e.queryIndex,
          path: e.$router.currentRoute.path,
        },
      });
      event.preventDefault();
    },
    columnsSettingOpened() {
      let checks = this.columnsChecks || this.defaultCheckedKeys;
      checks = checks.filter(
        (t) =>
          this.arrayColumns.findIndex((t2) => t2._id == t && t2._hasChildren) ==
          -1
      );
      this.$refs.columnsTree.setCheckedKeys(checks);
    },
    handleColumnsCheck($node, data) {
      this.columnsChecks = data.checkedKeys.concat(data.halfCheckedKeys);
      this.doLayout();
    },

    // 行排序(暂时不支持树形结构)
    setSort() {
      const callback = () => {
        const el = this.$refs.learunTable.$el.querySelectorAll(
          ".el-table__body-wrapper > table > tbody"
        )[0];

        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onEnd: (evt) => {
            const oldindex = evt.oldIndex;
            const newindex = evt.newIndex;
            const targetRow = this.dataSource.splice(oldindex, 1)[0];
            this.dataSource.splice(newindex, 0, targetRow);
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              this.dataSource
            );
          },
        });
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },

    findTreeItem(arr, res) {
      arr.forEach((t) => {
        res.push({ value: t.value, label: t.label });
        if (t.children) {
          this.findTreeItem(t.children, res);
        }
      });
    },

    getSummaries(param) {
      this.$nextTick(() => {
        this.$refs.learunTable.doLayout();
      });

      if (this.summaryMethod) {
        return this.summaryMethod(param);
      }

      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.sumText;
          return;
        }

        const myColumn = this.arrayColumns.find(
          (t) => t.prop == column.property
        );

        if (myColumn && myColumn.isSummary) {
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            //sums[index] += ' 元';
          } else {
            sums[index] = "N/A";
          }
        } else {
          sums[index] = "";
        }
      });
      if (this.sumsIsMoney && this.toThousandthAmount) {
        for (let index = 0; index < sums.length; index++) {
          const element = sums[index];
          if (typeof element == "number") {
            sums[index] = this.toThousandthAmount(sums[index]);
          }
        }
      }
      return sums;
    },
    isRequired(property) {
      let myColumn = this.arrayColumns.find((t) => t.prop == property);
      if (!myColumn) {
        return false;
      }
      return myColumn.required;
    },
    validate() {
      let res = true;
      if (this.required) {
        if (this.dataSource.length == 0) {
          this.$message({
            type: "error",
            message: this.$t(`请添加表格数据`),
          });
          return false;
        }
      }
      try {
        this.dataSource.forEach((row, index) => {
          this.arrayColumns.forEach((col) => {
            if (!col.isHidden) {
              if (col.required && this.$validatenull(row[col.prop])) {
                this.$message({
                  type: "error",
                  message: this.$t(`请输入第${index + 1}行-${col.label}`),
                });
                res = false;
                throw new Error();
              }

              if (col.patterns && col.patterns.length > 0) {
                col.patterns.forEach((pattern) => {
                  if (
                    pattern.reg &&
                    !this.$validatenull(row[col.prop]) &&
                    !new RegExp(
                      pattern.reg.substring(1, pattern.reg.length - 1)
                    ).test(row[col.prop])
                  ) {
                    this.$message({
                      type: "error",
                      message: this.$t(
                        `${pattern.msg}第${index + 1}行-${col.label}`
                      ),
                    });
                    res = false;
                    throw new Error();
                  }
                });
              }
            }
          });
        });
      } catch (error) {}
      return res;
    },
  },
};
</script>
<style lang="less">
@import "./index.less";

/*解决表格fixed错位问题*/
.el-table th > .cell {
  white-space: nowrap; /* 文本在一行显示，不换行 */
  text-overflow: ellipsis; /* 显示省略符号来代表被修剪的文本。*/
  overflow: hidden; /* 超出部分隐藏 */
}
</style>
